import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (pwd210)
// ============================================================

export interface FD210 {
  fd210_01: string;        // 入庫單號 (PK)
  fd210_11: string | null; // 入單日期 (ISO string)
  fd210_12: string;        // 入單人員
  fd210_13: number;        // 入庫類型 (1=繳庫, 2=托工)
  fd210_14: string;        // 驗布種類
  fd210_21: number;        // 總項數
  fd210_31: string;        // 廠商代號
  fd210_32: string | null; // 預計出貨日 (ISO string)
  fd210_33: string;        // 包裝代號
  fd210_34: boolean;       // 後段需上膠-需標上上膠面
  fd210_35: boolean;       // 布匹分正反面
  fd210_36: boolean;       // 驗布定長為100M-只允許1個接疋
  fd210_37: boolean;       // 更換白色紙管
  fd210_38: boolean;       // 打馬克槍
  fd210_39: boolean;       // 留布頭/布尾
  fd210_40: string;        // 驗貨指示 (memo)

  // Associations
  details?: FD211[];
}

export interface FD211 {
  fd211_01: string;   // 主表單號 (FK→FD210)
  fd211_02: number;   // 項次
  fd211_11: string;   // 產品代號（剪樣布）
  fd211_12: number;   // 入庫量
  fd211_13: number;   // 入庫金額
}

// ============================================================
// Request / Response types
// ============================================================

export interface Pwd210ListResponse {
  data: FD210[];
  total: number;
  page: number;
  size: number;
}

export interface Pwd210CreateRequest {
  master: Partial<FD210>;
  details: Partial<FD211>[];
}

// ============================================================
// API methods
// ============================================================

export interface SourceReceipt { doc_no: string; source_type: number; receipt_date: string | null; vendor: string; }

export const pwd210Api = {
  async sourceReceipts(sourceType: number, start: string, end: string, page = 1): Promise<{data: SourceReceipt[]; total: number; page: number; size: number}> {
    const res = await apiClient.get("/api/pwd210/source-receipts", { params: { source_type: sourceType, start, end, page, size: 20 } });
    return res.data;
  },
  async sourceDraft(sourceType: number, id: string): Promise<FD210> {
    const res = await apiClient.get("/api/pwd210/source-receipts/" + encodeURIComponent(id), { params: { source_type: sourceType } });
    return res.data;
  },
  async list(page = 1, size = 20): Promise<Pwd210ListResponse> {
    const res = await apiClient.get('/api/pwd210', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FD210> {
    const res = await apiClient.get(`/api/pwd210/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: Pwd210CreateRequest): Promise<FD210> {
    const res = await apiClient.post('/api/pwd210', data);
    return res.data;
  },

  async update(id: string, data: Pwd210CreateRequest): Promise<FD210> {
    const res = await apiClient.put(`/api/pwd210/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/pwd210/${encodeURIComponent(id)}`);
  },

  // Lookup: get display name for a reference table code
  // type: employee | vendor | packing
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pwd210/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
